module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0064.jpg?v=b62b4e6b";